import { s as scriptsConfig } from './built-config-a65ae98c.js';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

/**
 * List of production domains
 * Can be set as a comma-delimited list via a `PRODUCTION_DOMAINS` environment variable
 */
const PRODUCTION_DOMAINS =  ['www.decathlon.com'];
/**
 * List of staging domains
 * Can be set as a comma-delimited list via a `STAGING_DOMAINS` environment variable
 */

const STAGING_DOMAINS =  ['testing-decathlon-usa.myshopify.com'];
/**
 * The production Persistent Cart app API URL
 */

const PRODUCTION_API_URL =  'https://persistent-cart-decathlonusa-p.herokuapp.com';
/**
 * The staging Persistent Cart app API URL
 */

const STAGING_API_URL =  'https://persistent-cart-decathlonusa-s.herokuapp.com';
/**
 * Persistent Cart client-side config
 */

const config = {
  /**
   * URL for sending GQL requests. Can be set on process.env or use a local
   * @TODO - How to setup for production (Discuss with DE Team)?
   * Consider removing local definition
   */
  get API_URL() {
    const LOCAL_API_URL = 'http://localhost:8080'; // Set default to local

    let persistentCartUrl = LOCAL_API_URL; // Because DRY

    const hostname = window.location.hostname; // Set to staging API URL if we match a staging domain
    // Regular Expressions are supported

    if (STAGING_DOMAINS.some(domain => hostname.match(new RegExp(domain)))) {
      persistentCartUrl = STAGING_API_URL;
    } // Set to production API URL if we match a production domain
    // Regular Expressions are supported


    if (PRODUCTION_DOMAINS.some(domain => hostname.match(new RegExp(domain)))) {
      persistentCartUrl = PRODUCTION_API_URL;
    } // Allow override via `DECATHLON_PERSISTENT_CART_URL` environment variable


    return ( persistentCartUrl) + "/shopify/graphql";
  },

  STORAGE: {
    PREFIX: 'de_pc_',

    get SHOPIFY_CART() {
      return this.PREFIX + "shopify_cart";
    },

    get LOGGED_IN() {
      return this.PREFIX + "logged_in";
    }

  },
  SHOPIFY_API: {
    GET_CART: '/cart.js',
    UPDATE_CART: '/cart/update.js',
    ADD_TO_CART: '/cart/add.js'
  },
  COOKIES: {
    CART: 'cart',
    CART_TS: 'cart_ts',
    CART_SIG: 'cart_sig',
    CART_CURRENCY: 'cart_currency'
  },

  get ALL_CART_COOKIES() {
    return Object.keys(this.COOKIES).map(key => this.COOKIES[key]);
  },

  get CART_COOKIE() {
    return this.COOKIES.CART;
  }

};

/**
 * A custom implementation (not a fork) of the NPM module `nanographql`
 * The original module stringified variables and then stringified the entire data object,
 * leading to a payload format that would not work with the Shopify Storefront API.
 * This version is amended to pass our ESLint setup
 * @see https://github.com/yoshuawuyts/nanographql
 */
const getOpname = /(query|mutation) ?([\w\d-_]+)? ?\(.*?\)? \{/;
function nanographql(str) {
  const _str = Array.isArray(str) ? str.join('') : str;

  const name = getOpname.exec(_str);
  return function (variables) {
    const data = {
      query: _str
    };
    if (variables) data.variables = variables;

    if (Array.isArray(name) && name[2]) {
      const operationName = name[2];

      if (operationName) {
        data.operationName = name[2];
      }
    }

    return JSON.stringify(data);
  };
}

function _templateObject() {
  const data = _taggedTemplateLiteralLoose(["\n      query Products($count: Int!, $query: String!) {\n        products(first: $count, query: $query) {\n          edges {\n            node {\n              id\n              title\n              handle\n              vendor\n              isAvailable: availableForSale\n              featuredImage: images(first: 1, maxWidth: 200, maxHeight: 200) {\n                edges {\n                  node {\n                    id\n                    altText\n                    originalSrc\n                    transformedSrc\n                  }\n                }\n              }\n              # first or last is required, we want all variants, 100 seems reasonable\n              variants(first: 100) {\n                edges {\n                  node {\n                    id\n                    isAvailable: availableForSale\n                    isCurrentlyNotInStock: currentlyNotInStock\n                    price: priceV2 {\n                      amount\n                      currencyCode\n                    }\n                    compareAtPrice: compareAtPriceV2 {\n                      amount\n                      currencyCode\n                    }\n                    image(maxWidth: 200, maxHeight: 200) {\n                      id\n                      altText\n                      originalSrc\n                      transformedSrc\n                    }\n                    selectedOptions {\n                      name\n                      value\n                    }\n                  }\n                }\n              }\n              ratings: metafield(namespace: \"ratings\", key: \"product_rating\") {\n                value\n              }\n              reviews: metafield(\n                namespace: \"reviews\"\n                key: \"recent_reviews_object\"\n              ) {\n                value\n              }\n              manualRatings: metafield(\n                namespace: \"ratings\"\n                key: \"manual_product_rating\"\n              ) {\n                value\n              }\n              manualReviews: metafield(\n                namespace: \"reviews\"\n                key: \"manual_reviews_object\"\n              ) {\n                value\n              }\n              tags\n            }\n          }\n        }\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
const {
  STOREFRONT_API,
  NO_CACHE_HEADERS
} = scriptsConfig;
/**
 * Generic function for issuing a GQL query or mutation
 * @param {*} query - A GQL query
 * @param {Object} data - Data to pass to the query
 * @param {string} [url] - A request URL, which, if passed, will override the default
 * @param {Object} [extraConfig = {}] - Additional configuration used to add to the existing request configuration
 * @returns {Promise<Object>} - Data returned from the GQL query or mutation
 */

const makeRequest = (query, data, url, extraConfig = {}) => fetch(url || config.API_URL, {
  body: query(data),
  method: 'POST',
  headers: Object.assign({
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }, extraConfig.headers),
  credentials: 'same-origin'
}).then(response => {
  if (!response.ok) {
    const message = response.statusText;
    throw new Error("Failed GQL request. Status: " + response.status + (message && "; message: " + message));
  }

  return response.json();
})
/**
 * GQL usually returns either only `data` or `errors`, which is an array of
 * objects, but `errors` are the result of a malformed request (not HTTP errors)
 * @see https://stackoverflow.com/questions/52778096/how-to-return-both-error-and-data-in-a-graphql-resolver#52780113
 */
.then(({
  data,
  errors
}) => {
  let errorMessages;

  if (errors) {
    /**
     * Reduce all error messages to a comma-delimited string (only
     * one string if there's only one error)
     */
    errorMessages = errors.reduce((acc, err, idx) => "" + acc + (idx > 0 ? ', ' : '') + err.message, '');
  } // Throw if there is no data, only errors


  if (!data && errors) {
    throw new Error("Malformed GQL request. Errors: " + errorMessages);
  } // Log if there are errors but also data


  if (errors) {
    /**
     * Log a new error with one or more messages about why this request
     * failed, for debugging purposes
     */
    console.error('Malformed GQL request: ', errorMessages);
  }

  return data;
});
/**
 * Make a request, passing along extra headers to enforce no caching of the response
 * @param {*} query - A GQL query
 * @param {Object} data - Data to pass to the query
 * @param {string} [url] - A request URL, which, if passed, will override the default
 * @param {Object} [extraConfig = {}] - Additional configuration used to add to the existing request configuration
 * @returns {Promise<Object>} - Data returned from the GQL query or mutation
 */

const makeUncachedRequest = (query, data, url, extraConfig = {}) => {
  return makeRequest(query, data, url, {
    headers: Object.assign({}, NO_CACHE_HEADERS, extraConfig.headers)
  });
};
/**
 * Make a GraphQL request to the Shopify Storefront API by passing an override URL and additional configuration
 * to the underlying `makeRequest` master GraphQL request function
 * @param {*} query - A tagged template literal that will be used to create a GraphQL request using passed-in data
 * @param {Object} data - The data to be passed to a GraphQL query
 * @returns {Promise<Object>} - Data returned from the GQL query or mutation
 */

const makeShopifyStorefrontRequest = (query, data) => {
  const headers = {};
  headers[STOREFRONT_API.HEADER_NAME] = STOREFRONT_API.KEY;
  return makeUncachedRequest(query, data, STOREFRONT_API.URL, {
    headers
  });
};
/**
 * Make a GraphQL request to the Shopify Storefront API by passing an override URL and additional configuration
 * to the underlying `makeRequest` master GraphQL request function
 * @param {object} props
 * @param {number} props.count The product count to fetch
 * @param {string} props.query The query for the GraphQL products ProductConnection
 * @returns {Promise<Object>} - Data returned from the GQL query or mutation
 */

const getProductTileData = ({
  count,
  query
}) => {
  const headers = {};
  headers[STOREFRONT_API.HEADER_NAME] = undefined;
  return makeRequest(
  /* eslint-disable graphql/template-strings */
  nanographql(_templateObject()),
  /* eslint-enable */
  {
    count,
    query
  }, '/api/2020-04/graphql.json', {
    headers
  });
};

export { _taggedTemplateLiteralLoose as _, makeUncachedRequest as a, getProductTileData as g, makeShopifyStorefrontRequest as m, nanographql as n, config as p };
